module.exports = __webpack_public_path__ + "static/media/Woman.54fc8229.svg";